var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7628 12.2763C23.7628 11.4605 23.6966 10.6404 23.5555 9.83789H12.2368V14.4589H18.7185C18.4495 15.9492 17.5853 17.2676 16.3198 18.1054V21.1037H20.1868C22.4576 19.0137 23.7628 15.9272 23.7628 12.2763Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2372 24.0003C15.4737 24.0003 18.2031 22.9377 20.1917 21.1034L16.3247 18.1051C15.2488 18.837 13.8599 19.2515 12.2416 19.2515C9.11102 19.2515 6.4566 17.1394 5.50418 14.2998H1.51373V17.3907C3.55085 21.4429 7.70003 24.0003 12.2372 24.0003Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49972 14.3002C4.99706 12.8099 4.99706 11.196 5.49972 9.70569V6.61475H1.51368C-0.188318 10.0055 -0.188318 14.0004 1.51368 17.3912L5.49972 14.3002Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2373 4.74966C13.9481 4.7232 15.6016 5.36697 16.8406 6.54867L20.2667 3.12262C18.0973 1.0855 15.218 -0.034466 12.2373 0.000808666C7.70009 0.000808666 3.55091 2.55822 1.51379 6.61481L5.49983 9.70575C6.44784 6.86173 9.10667 4.74966 12.2373 4.74966Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.a3e393322bda5d2b2917b5c7cd38af1f.svg";
export { ForwardRef as ReactComponent };